<template>
  <div>
    <mainVue>
      <template v-slot:main="main">
        <div :key="index" v-for="(item, index) in main.data">
          <specialVue :data-list="[item]" v-if="findCategory(item)==1"></specialVue>
          <authorVue :data-list="[item]" v-if="findCategory(item)==2"></authorVue>
          <videoVue :data-list="[item]" v-if="findCategory(item)==3"></videoVue>
          <imageVue :data-list="[item]" v-if="findCategory(item)==4"></imageVue>
          <audioVue :data-list="[item]" v-if="findCategory(item)==5"></audioVue>
        </div>
      </template>
    </mainVue>
  </div>
</template>

<script>
  import mainVue from '../../../components/resource/main.vue'
  import audioVue from '../../../components/resource/audio.vue';
  import authorVue from '../../../components/resource/author.vue';
  import imageVue from '../../../components/resource/image.vue';
  import specialVue from '../../../components/resource/special.vue';
  import videoVue from '../../../components/resource/video.vue';

  export default {
    name: 'PortalInBooks',
    components: {
      audioVue, mainVue, authorVue, imageVue, specialVue, videoVue
    },
    data() {
      return {};
    },

    mounted() {
    },

    methods: {
      findCategory(item) {
        return item.categoryName == '古籍底本' ? '1' : item.categoryName == '精品图书' ? '2' : item.categoryName == '民俗视频' ? '3' : item.categoryName == '民俗图片' ? '4' : item.categoryName == '民俗音频' ? '5' : ''
      }
    },
  };
</script>

<style lang="less" scoped>

</style>
